module.exports = __webpack_public_path__ + "static/salon-pasajeros---paqueteras-9359843291790a0659319445d6e0220e.jpg";